import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, rgba(250,251,255,1) 0%, rgba(236,240,255,1) 100%)",
        pt: { xs: 8, md: 12 },
        pb: { xs: 16, md: 14 },
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                textAlign: { xs: "center", md: "left" },
                position: "relative",
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
              >
                <Typography
                  component="h1"
                  variant="h2"
                  fontWeight="800"
                  mb={2}
                  color="text.primary"
                  sx={{
                    fontSize: { xs: "2.5rem", md: "3.5rem" },
                    lineHeight: 1.2,
                  }}
                >
                  Digital Solutions for{" "}
                  <Box component="span" sx={{ color: "primary.main" }}>
                    Small Businesses
                  </Box>
                </Typography>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                <Typography
                  variant="h6"
                  color="text.secondary"
                  mb={4}
                  sx={{ fontWeight: 400 }}
                >
                  Web development, mobile apps, cloud solutions, and digital
                  marketing tailored for local businesses like artist workshops,
                  fitness trainers, and small business owners.
                </Typography>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: { xs: "center", md: "flex-start" },
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => {
                      document
                        .getElementById("contact")
                        .scrollIntoView({ behavior: "smooth" });
                    }}
                    sx={{
                      px: 4,
                      py: 1.5,
                      borderRadius: "30px",
                      fontWeight: 600,
                    }}
                  >
                    Get Started
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    onClick={() => {
                      document
                        .getElementById("projects")
                        .scrollIntoView({ behavior: "smooth" });
                    }}
                    sx={{
                      px: 4,
                      py: 1.5,
                      borderRadius: "30px",
                      fontWeight: 600,
                    }}
                  >
                    View Projects
                  </Button>
                </Box>
              </motion.div>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              style={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  maxWidth: "500px",
                  height: { xs: "300px", md: "400px" },
                  mb: { xs: 12, md: 10 },
                }}
              >
                {/* Abstract shapes for visual interest */}
                <Box
                  sx={{
                    position: "absolute",
                    width: "220px",
                    height: "220px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #5271FF 0%, #B8A4FD 100%)",
                    opacity: 0.2,
                    filter: "blur(40px)",
                    top: "-30px",
                    right: "20px",
                    zIndex: 0,
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    width: "180px",
                    height: "180px",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #FF914D 0%, #FFBE9D 100%)",
                    opacity: 0.2,
                    filter: "blur(40px)",
                    bottom: "0px",
                    left: "40px",
                    zIndex: 0,
                  }}
                />

                {/* Profile image with themed border */}
                <Box
                  component="img"
                  src="images/Ericremovebg2.png"
                  alt="Eric Rak - Digital Solutions Developer"
                  sx={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    objectFit: "contain",
                    position: "relative",
                    borderRadius: "50%", // Make it circular
                    border: (theme) => `4px solid ${theme.palette.primary.main}`, // Themed border
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                    zIndex: 1,
                    overflow: "hidden",
                    maxWidth: "400px",
                    margin: "0 auto"
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
